import { Col, Row } from "react-bootstrap"
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { withTranslation } from "react-i18next";

function TableSearch({t, columns, items, className,placeholderSearch}){
    const { SearchBar } = Search;

    return (
        <Row>
            <Col>
            <ToolkitProvider
                keyField="id"
                data={ items }
                columns={ columns }
                search
                >
                {
                    props => (
                    <div>
                        
                        <SearchBar { ...props.searchProps } 
                            placeholder ={`${t('buscar')} ${placeholderSearch ? placeholderSearch : ''}`}
                            className="input-search"
                        />
                        <hr />
                        <BootstrapTable 
                        { ...props.baseProps }
                            keyField='id' 
                            data={ items } 
                            columns={ columns } 
                            bordered={false}
                            classes={`border-top-0 simple-table ${className}`}
                            wrapperClasses="table-responsive"
                            noDataIndication={t('no_informacion_disponible')}
                            pagination={ paginationFactory() }
                        />
                    </div>
                    )
                }
            </ToolkitProvider>
            </Col>
        </Row>
    )

}

export default withTranslation()(TableSearch)